import { useSelector } from 'react-redux';

/**
 * Include / exclude switch for the option list.
 *
 * A mode is modal state, and the failure it invites is picking values in
 * the wrong one. Two things guard against that: the popover always
 * reopens on Include (see the owner component), and the option rows
 * themselves render a red minus instead of a blue tick while Exclude is
 * active — so the mode is legible at the point of action, not only here.
 */
const PlusIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const MinusIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const ModeToggle = ({ mode, onChange }) => {
  const { tables } = useSelector(state => state.i18n);

  return (
    <div className="qhs-dynh-mode" role="group" aria-label={tables?.filterMode || 'Filter mode'}>
      <button
        type="button"
        className="qhs-dynh-mode__btn"
        aria-pressed={mode === 'include'}
        onClick={() => onChange('include')}
      >
        <PlusIcon />
        {tables?.includeGroup || 'Include'}
      </button>
      <button
        type="button"
        className="qhs-dynh-mode__btn qhs-dynh-mode__btn--exclude"
        aria-pressed={mode === 'exclude'}
        onClick={() => onChange('exclude')}
      >
        <MinusIcon />
        {tables?.excludeGroup || 'Exclude'}
      </button>
    </div>
  );
};

export default ModeToggle;
